module.exports = new __parcel__URL__("customer-contracts.bbe79455.html").toString();